export enum BACK_TO_PARTNER_LINK_TYPES {
   SUCCESS = 'SUCCESS',
   FAILURE = 'FAILURE'
}

export interface IBackToPartnerProps {
   className?: string;
   linkType: BACK_TO_PARTNER_LINK_TYPES;
   isFromVideoVerification?: boolean;
}